import React, { Fragment, useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from "react-datepicker"

import { httpOk, GET, POST, PUT, FILE_D } from 'helpers/api'
import { formatDate, returnSign, formatMoneyInput, formatMoney, buildCashAccountSelectOptions, getAccountSelectProps, pickCashAccountId } from "helpers/helpers"

function Index() {
	const { t } = useTranslation()
	const date = new Date()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [ppt, setPPT] = useState([])
	const [accounts, setAccounts] = useState([])
	const [modalPayment, setModalPayment] = useState(false)
	const [showModal, setShowModal] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		pos_id: reduxAccount.pos_id,
		random: 0,
	})

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/kpi-scores"
		var urlParams = ""

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date

		if (passedData['excel']) {
			urlParams += returnSign(urlParams) + 'excel=true'

			const responseExcel = await FILE_D(filterUrl + urlParams)
			if (httpOk(responseExcel)) {
				// Создаем объект Blob из полученного файла
				const file = new Blob([responseExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Создаем ссылку для скачивания файла
				const fileUrl = URL.createObjectURL(file);

				// Создаем ссылку для скачивания файла в браузере
				const link = document.createElement('a');
				link.href = fileUrl;
				link.setAttribute('download', `kpi.xlsx`);
				document.body.appendChild(link);
				link.click();

				// Удаляем ссылку после скачивания файла
				URL.revokeObjectURL(fileUrl);
			}
			return
		}

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setDropdownIsOpen(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function createUpdate(e) {
		e.preventDefault()

		if (selectedItem.pay) {
			toggleModalPayment()
			return
		}

		var response;
		if (selectedItem.id) {
			response = await PUT('/kpi-scores', selectedItem, { loader: true })
		} else {
			response = await POST('/kpi-scores', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
			setModalPayment(false)
		}
	}

	async function toggleModal(bool = false, item = {}, params = { score: {}, date: null }) {
		var itemCopy = { ...item }
		itemCopy.created_at = params.date

		if (bool) {
			if (typeof params.score === 'object' && params.score !== null && Object.keys(params.score).length > 0) {
				var response = await POST('/kpi-scores-date', {
					'user_id': item.user_id,
					'created_at': itemCopy.created_at,
				}, { loader: true })

				if (httpOk(response)) {
					itemCopy.kpi_types = response.data.data
					itemCopy.total_amount = response.data.total_amount
				}
			} else {
				itemCopy.kpi_types = []
				for (let i = 0; i < data.kpi_types.length; i++) {
					if (item.kpi_group_id === data.kpi_types[i]['kpi_group_id'])
						itemCopy.kpi_types.push(data.kpi_types[i])
				}
			}
		}

		setSelectedItem(itemCopy)
		setShowModal(bool)
	}

	async function toggleModalPayment() {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy.pay = false
		selectedItemCopy.amount = selectedItemCopy.total_amount

		setShowModal(false)
		setModalPayment(true)
		setSelectedItem(selectedItemCopy)
	}

	function handleChange(e, index) {
		var selectedItemCopy = { ...selectedItem }
		console.log(selectedItemCopy)
		if (selectedItemCopy.kpi_types[index]['max_score'] && (Number(e.target.value) <= selectedItemCopy.kpi_types[index]['max_score'])) {
			selectedItemCopy.kpi_types[index]['score'] = e.target.value.replace(/[^0-9.]/g, '')

			if (selectedItemCopy.kpi_types[index]['type_amount']) {
				selectedItemCopy.kpi_types[index]['amount'] = selectedItemCopy.kpi_types[index]['type_amount'] / selectedItemCopy.kpi_types[index]['score']
			}
		}

		if (!selectedItemCopy.kpi_types[index]['max_score'] && Number(e.target.value) <= 100)
			selectedItemCopy.kpi_types[index]['score'] = e.target.value.replace(/[^0-9.]/g, '')

		calculateTotalAmount(selectedItemCopy)
	}

	function handleChangeTA(e) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy.total_amount = Number(e.target.value)

		calculateTotalAmount(selectedItemCopy)
	}

	function calculateTotalAmount(selectedItemCopy) {
		selectedItemCopy.total_amount = 0;

		// const totalScore = selectedItemCopy.kpi_types.reduce((sum, kpi) => {
		// 	const score = parseInt(kpi.score) || 0;
		// 	return sum + score;
		// }, 0);

		let result = [];
		result = selectedItemCopy.kpi_types.map(kpi => {
			if (kpi.score > 0) {
				return {
					...kpi,
					amount: Math.ceil((kpi.type_amount / kpi.max_score) * kpi.score)
				};
			} else {
				return {
					...kpi,
					amount: 0
				};
			}
		});

		for (let i = 0; i < result.length; i++) {
			selectedItemCopy.total_amount += result[i]['amount'] ? result[i]['amount'] : 0;
		}

		// result = selectedItemCopy.kpi_types.map(kpi => {
		// 	const score = parseInt(kpi.score) || 0;
		// 	const amount = (score / totalScore) * selectedItemCopy.total_amount;

		// 	return {
		// 		...kpi,
		// 		'amount': parseFloat(amount.toFixed(0))
		// 	};
		// });

		selectedItemCopy.kpi_types = result
		setSelectedItem(selectedItemCopy)
	}

	async function getPoses() {
		var response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	async function getPPT() {
		const response = await GET('/helper/ppt-expense?counterparty=employee_salary')
		if (httpOk(response)) setPPT(response.data)
	}

	useEffect(() => {
		getPoses()
		getPPT()
		getAccounts()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const accountChefOptions = buildCashAccountSelectOptions(accounts)

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('scores')}
				</h4>
				<div className="d-flex d-none">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('date')}</label>
												<div className="calendar-input">
													<DatePicker
														showMonthDropdown
														showYearDropdown
														dropdownMode="select"
														yearDropdownItemNumber={2}
														minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
														maxDate={new Date(new Date().getFullYear(), 11, 31)}
														showMonthYearPicker
														showFullMonthYearPicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button type="button" className="btn btn-outline-primary btn-wide-2"
									onClick={() => searchWithFilter({ 'excel': true })}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
					</div>

					{data?.data?.map((kpiGroup, kpiGroupIndex) => (
						<Fragment key={kpiGroupIndex}>
							{!!kpiGroup.employees.length &&
								<>
									<h5>{kpiGroupIndex + 1}. {kpiGroup.name}</h5>
									<div className="table-responsive mb-3">
										<table className="table table-bordered mb-0">
											<thead>
												<tr>
													<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
													<th style={{ 'minWidth': '120px' }}>{t('name2')}</th>
													{data?.days?.map((item, index) => (
														<th key={index} style={{ 'minWidth': '100px' }} className="text-center">
															{formatDate(item.date, 'dd.MM.yy')}
														</th>
													))}
													<th style={{ 'minWidth': '100px' }} className="text-end">{t('total')}</th>
												</tr>
											</thead>
											<tbody>
												{kpiGroup?.employees?.map((item, index) => (
													<tr key={index}>
														<td className="text-center">{index + 1}</td>
														<td className="td-ellipsis">{item.employee_name}</td>
														{/* {data?.days?.map((day, dIndex) => (
															<td key={dIndex} className="text-end td-hover"
																onClick={() => toggleModal(true, item, { 'score': item.daily_scores[day.date], 'date': day.date })}>
																{item.daily_scores[day.date]}
															</td>
														))} */}

														{data?.days?.map((day, dIndex) => {
															const kpiEntries = item.typed_scores?.[day.date]
																? Object.entries(item.typed_scores[day.date])
																: [];

															return (
																<td key={dIndex} className="text-start td-hover"
																	onClick={() => toggleModal(true, item, {
																		score: item.typed_scores[day.date],
																		date: day.date
																	})}>

																	{kpiEntries.length > 0 ? (
																		<>
																			{kpiEntries.map(([kpiName, score], i) => (
																				<div className="d-flex justify-content-between" key={i}>
																					{kpiName}: <b>{score}</b>
																				</div>
																			))}

																			{/* Только если KPI есть */}
																			<hr className="my-1" />
																			<div className="d-flex justify-content-between fw-bold">
																				{t('total')}: <span>{item.total_scores?.[day.date] ?? 0}</span>
																			</div>
																		</>
																	) : (
																		<div></div>
																	)}
																</td>
															);
														})}
														<td className="text-center">
															{/* {item.monthly_score} */}
															{Object.entries(item.kpi_monthly_total || {}).map(([kpiName, sum], index) => (
																<div className="d-flex justify-content-between" key={index}>
																	{kpiName}: <b>{sum}</b>
																</div>
															))}
															{Object.keys(item.kpi_monthly_total || {}).length > 0 && (
																<>
																	<hr className="my-1" />
																	<div className="d-flex justify-content-between fw-bold">
																		{t('total')}: <span>{item.monthly_score_types ?? 0}</span>
																	</div>
																</>
															)}
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</>
							}
						</Fragment>
					))}

				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="table-responsive" style={{ 'minHeight': '300px' }}>
							<table className="table table-bordered" style={{ 'overflow': 'unset' }} >
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '60%' }}>{t('type')}</th>
										<th style={{ 'width': '20%' }} className="text-end">{t('rating')}</th>
										<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{selectedItem?.kpi_types?.map((item, index) => (
										<tr key={index}>
											<td className="text-center">{index + 1}</td>
											<td>{item.name}</td>
											<td className="td-input">
												<input
													type="text"
													name="score"
													className="form-control text-end"
													placeholder={`${item.max_score ?? ''}`}
													value={item.score ?? ''}
													onChange={(e) => handleChange(e, index)} />
											</td>
											<td className="td-input">
												<input
													disabled
													type="text"
													name="amount"
													className="form-control text-end"
													placeholder={`${formatMoney(item.type_amount) ?? ''}`}
													value={formatMoney(item.amount) ?? ''}
													onChange={(e) => handleChange(e, index)} />
											</td>
										</tr>
									))}
									<tr>
										<td></td>
										<td><b>{t('total')}</b></td>
										<td></td>
										<td className="td-input">
											<input
												disabled
												type="text"
												name="total_amount"
												className="form-control text-end"
												value={selectedItem.total_amount ? formatMoney(selectedItem.total_amount) : ''}
												onChange={(e) => handleChangeTA(e)} />
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div>
							<div className="form-check d-none">
								<input className="form-check-input" type="checkbox" id="pay"
									onChange={(e) => setSelectedItem({ ...selectedItem, 'pay': e.target.checked })} />
								<label className="form-check-label" htmlFor="pay">
									{t('pay')}
								</label>
							</div>
							<div className="d-flex gap-2 w-100 mt-3">
								<button type="button" className="btn btn-outline-warning w-100"
									onClick={() => toggleModal()}>
									{t('cancel')}
								</button>
								<button type="submit" className="btn btn-primary w-100">
									{t('save')}
								</button>
							</div>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			{/* MODAL PAYMENT*/}
			<Modal
				show={modalPayment}
				animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalPayment(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						<span>{selectedItem.employee_name}</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('date')}</label>
							<div className="calendar-input">
								<DatePicker
									showMonthDropdown
									showYearDropdown
									dropdownMode="select"
									yearDropdownItemNumber={2}
									disabled={selectedItem.update}
									className="form-control"
									dateFormat="dd.MM.yyyy"
									selected={selectedItem.created_at ? new Date(selectedItem.created_at) : ''}
									onChange={(date) => setSelectedItem({ ...selectedItem, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
									maxDate={new Date()}
								/>
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>
						<>
							<div className="form-group">
								<label>{t('expense_type')}</label>
								<Select
									options={ppt}
									value={ppt.find(option => option.id === selectedItem.payment_purpose_id)}
									onChange={(option) => setSelectedItem({
										...selectedItem, 'payment_purpose_id': option.id,
										'account_chef_id': pickCashAccountId(accounts, option.account_chef_id),
										'account_core_id': option.account_core_id,
									})}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group">
								<label>{t('operation_account')}<span className="required-mark">*</span></label>
								<Select
									isClearable
									{...getAccountSelectProps(t)}
									options={accountChefOptions}
									value={accountChefOptions.find(option => option.id === selectedItem.account_chef_id) || null}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'account_chef_id': option ? option.id : null })}
								/>
							</div>
							<div className="form-group d-none">
								<label>{t('report_account')}</label>
								<Select
									isDisabled
									options={accounts}
									value={accounts.find(option => option.id === selectedItem.account_core_id)}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'account_core_id': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						</>
						<div className="form-group">
							<label>{t('amount')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="amount"
								disabled
								value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100" onClick={() => setModalPayment(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT*/}
		</>
	)
}

export default Index